/**
 * Datová třída, pro předání jako argumentu funkci a možnost zápisu generické hodnoty pro použití vně funkce jako další výsledek
 */
export class OutputParameter<T> {
    private _value?: T;

    constructor(value?: T) {
        this._value = value;
    }

    public get value(): T | undefined {
        return this._value;
    }

    public set value(value: T | undefined) {
        this._value = value;
    }
}
